window.PRODUCTS = [
 {
  "handle": "the-shea-t-shirt-dress-white",
  "title": "The Shea T-Shirt Dress",
  "style": "shea",
  "color": "White",
  "price": 198,
  "inv": 145,
  "badge": "BESTSELLER",
  "img": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-shea-t-shirt-dress-white-0.jpg?v=156539218139546518411793801409",
  "img2": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-shea-t-shirt-dress-white-1.jpg?v=172042547133329999451793801410",
  "sizes": [
   {
    "s": "XS",
    "q": 53
   },
   {
    "s": "S",
    "q": 62
   },
   {
    "s": "M",
    "q": 22
   },
   {
    "s": "L",
    "q": 8
   }
  ],
  "set_pieces": [],
  "look_pieces": [],
  "fit_ok": true
 },
 {
  "handle": "the-shea-t-shirt-dress",
  "title": "The Shea T-Shirt Dress",
  "style": "shea",
  "color": "Black",
  "price": 198,
  "inv": 33,
  "badge": "BESTSELLER",
  "img": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-shea-t-shirt-dress-1.jpg?v=140235477530670641571793801405",
  "img2": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-shea-t-shirt-dress-2.jpg?v=490464256326120761793801405",
  "sizes": [
   {
    "s": "XS",
    "q": 7
   },
   {
    "s": "S",
    "q": 4
   },
   {
    "s": "M",
    "q": 13
   },
   {
    "s": "L",
    "q": 9
   }
  ],
  "set_pieces": [],
  "look_pieces": [],
  "fit_ok": true
 },
 {
  "handle": "the-shea-long-sleeve-t-shirt-dress-white",
  "title": "The Shea Long Sleeve T-Shirt Dress",
  "style": "shea",
  "color": "White",
  "price": 208,
  "inv": 12,
  "badge": "NEW IN",
  "img": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-shea-long-sleeve-t-shirt-dress-white-0.jpg?v=62147676084297339841793801403",
  "img2": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-shea-long-sleeve-t-shirt-dress-white-2.jpg?v=81145097735864854091793801404",
  "sizes": [
   {
    "s": "XS",
    "q": 5
   },
   {
    "s": "S",
    "q": 2
   },
   {
    "s": "M",
    "q": 2
   },
   {
    "s": "L",
    "q": 3
   }
  ],
  "set_pieces": [],
  "look_pieces": [],
  "fit_ok": true
 },
 {
  "handle": "the-shea-long-sleeve-t-shirt-dress",
  "title": "The Shea Long Sleeve T-Shirt Dress",
  "style": "shea",
  "color": "Black",
  "price": 208,
  "inv": 20,
  "badge": "",
  "img": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-shea-long-sleeve-t-shirt-dress-0.jpg?v=10214762205855513861793801400",
  "img2": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-shea-long-sleeve-t-shirt-dress-1.jpg?v=146937835180838061331793801400",
  "sizes": [
   {
    "s": "XS",
    "q": 7
   },
   {
    "s": "S",
    "q": 4
   },
   {
    "s": "M",
    "q": 4
   },
   {
    "s": "L",
    "q": 5
   }
  ],
  "set_pieces": [],
  "look_pieces": [],
  "fit_ok": true
 },
 {
  "handle": "the-paige-beach-shirt",
  "title": "The Button-Up Beach Tunic",
  "style": "beach-shirt",
  "color": "White",
  "price": 188,
  "inv": 61,
  "badge": "",
  "img": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-paige-beach-shirt-0.jpg?v=145563845123567924491793801388",
  "img2": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-paige-beach-shirt-1.jpg?v=106892749078060127861793801390",
  "sizes": [
   {
    "s": "XS",
    "q": 26
   },
   {
    "s": "S",
    "q": 13
   },
   {
    "s": "M",
    "q": 12
   },
   {
    "s": "L",
    "q": 10
   }
  ],
  "set_pieces": [
   "the-vacation-pants-copy"
  ],
  "look_pieces": [
   "the-vacation-pants-copy"
  ],
  "fit_ok": true
 },
 {
  "handle": "the-paige-shirt",
  "title": "The Button-Up Beach Tunic",
  "style": "beach-shirt",
  "color": "Black",
  "price": 188,
  "inv": 71,
  "badge": "",
  "img": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-paige-shirt-0.jpg?v=20630359408703004451793801393",
  "img2": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-paige-shirt-1.jpg?v=130252866857493610671793801393",
  "sizes": [
   {
    "s": "XS",
    "q": 27
   },
   {
    "s": "S",
    "q": 0
   },
   {
    "s": "M",
    "q": 25
   },
   {
    "s": "L",
    "q": 19
   }
  ],
  "set_pieces": [
   "the-asher-shorts-3",
   "the-hailey-trouser-3"
  ],
  "look_pieces": [
   "the-asher-shorts-3",
   "the-hailey-trouser-3"
  ],
  "fit_ok": true
 },
 {
  "handle": "the-paige-shirt-stripe",
  "title": "The Button-Up Beach Tunic",
  "style": "beach-shirt",
  "color": "Stripe",
  "price": 188,
  "inv": 139,
  "badge": "BESTSELLER",
  "img": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-paige-shirt-stripe-0.jpg?v=42826994437688744071793801397",
  "img2": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-paige-shirt-stripe-1.jpg?v=147602428622007068941793801397",
  "sizes": [
   {
    "s": "XS",
    "q": 20
   },
   {
    "s": "S",
    "q": 39
   },
   {
    "s": "M",
    "q": 30
   },
   {
    "s": "L",
    "q": 50
   }
  ],
  "set_pieces": [
   "the-asher-shorts-2",
   "the-hailey-trouser-1"
  ],
  "look_pieces": [
   "the-asher-shorts-2",
   "the-hailey-trouser-1"
  ],
  "fit_ok": true
 },
 {
  "handle": "the-paige-beach-shirt-1",
  "title": "The Button-Up Beach Tunic",
  "style": "beach-shirt",
  "color": "Blue Stripe",
  "price": 188,
  "inv": 74,
  "badge": "",
  "img": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-paige-beach-shirt-1-0.jpg?v=161985649249749691091793801388",
  "img2": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-paige-beach-shirt-1-1.jpg?v=85582750540244649301793801389",
  "sizes": [
   {
    "s": "XS",
    "q": 28
   },
   {
    "s": "S",
    "q": 19
   },
   {
    "s": "M",
    "q": 8
   },
   {
    "s": "L",
    "q": 19
   }
  ],
  "set_pieces": [
   "the-hailey-trouser"
  ],
  "look_pieces": [
   "the-hailey-trouser"
  ],
  "fit_ok": true
 },
 {
  "handle": "the-beach-shirt",
  "title": "The Button-Up Beach Tunic",
  "style": "beach-shirt",
  "color": "Polka Dot",
  "price": 188,
  "inv": 110,
  "badge": "",
  "img": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-beach-shirt-1.jpg?v=32712552635036967971793801361",
  "img2": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-beach-shirt-2.jpg?v=163077574546712259701793801361",
  "sizes": [
   {
    "s": "XS",
    "q": 28
   },
   {
    "s": "S",
    "q": 26
   },
   {
    "s": "M",
    "q": 30
   },
   {
    "s": "L",
    "q": 26
   }
  ],
  "set_pieces": [
   "the-asher-shorts",
   "the-kaitlin-pants"
  ],
  "look_pieces": [
   "the-asher-shorts",
   "the-kaitlin-pants"
  ],
  "fit_ok": true
 },
 {
  "handle": "the-hailey-trouser-1",
  "title": "The Kaitlin Pants",
  "style": "kaitlin",
  "color": "Stripe",
  "price": 198,
  "inv": 238,
  "badge": "BESTSELLER",
  "img": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-hailey-trouser-1-1.jpg?v=100956783285475054281793801371",
  "img2": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-hailey-trouser-1-4.jpg?v=161275036559996540231793801372",
  "sizes": [
   {
    "s": "XS",
    "q": 64
   },
   {
    "s": "S",
    "q": 62
   },
   {
    "s": "M",
    "q": 71
   },
   {
    "s": "L",
    "q": 41
   }
  ],
  "set_pieces": [
   "the-paige-shirt-stripe",
   "the-asher-shorts-2"
  ],
  "look_pieces": [
   "the-paige-shirt-stripe",
   "the-asher-shorts-2"
  ],
  "fit_ok": true
 },
 {
  "handle": "the-hailey-trouser-3",
  "title": "The Kaitlin Pants",
  "style": "kaitlin",
  "color": "Black",
  "price": 198,
  "inv": 70,
  "badge": "",
  "img": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-hailey-trouser-3-0.jpg?v=22010523419846391621793801376",
  "img2": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-hailey-trouser-3-1.jpg?v=19734144707524378751793801376",
  "sizes": [
   {
    "s": "XS",
    "q": 18
   },
   {
    "s": "S",
    "q": 27
   },
   {
    "s": "M",
    "q": 10
   },
   {
    "s": "L",
    "q": 15
   }
  ],
  "set_pieces": [
   "the-paige-shirt",
   "the-asher-shorts-3"
  ],
  "look_pieces": [
   "the-paige-shirt",
   "the-asher-shorts-3"
  ],
  "fit_ok": true
 },
 {
  "handle": "the-hailey-trouser",
  "title": "The Kaitlin Pants",
  "style": "kaitlin",
  "color": "Blue Stripe",
  "price": 198,
  "inv": 116,
  "badge": "",
  "img": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-hailey-trouser-0.jpg?v=82050517509836242741793801370",
  "img2": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-hailey-trouser-1.jpg?v=121899355790301199611793801375",
  "sizes": [
   {
    "s": "XS",
    "q": 44
   },
   {
    "s": "S",
    "q": 35
   },
   {
    "s": "M",
    "q": 24
   },
   {
    "s": "L",
    "q": 13
   }
  ],
  "set_pieces": [
   "the-paige-beach-shirt-1"
  ],
  "look_pieces": [
   "the-paige-beach-shirt-1"
  ],
  "fit_ok": true
 },
 {
  "handle": "the-kaitlin-pants",
  "title": "The Kaitlin Pants",
  "style": "kaitlin",
  "color": "Polka Dot",
  "price": 198,
  "inv": 51,
  "badge": "",
  "img": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-kaitlin-pants-1.jpg?v=107828637072191248671793801382",
  "img2": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-kaitlin-pants-1.jpg?v=107828637072191248671793801382",
  "sizes": [
   {
    "s": "XS",
    "q": 6
   },
   {
    "s": "S",
    "q": 23
   },
   {
    "s": "M",
    "q": 14
   },
   {
    "s": "L",
    "q": 8
   }
  ],
  "set_pieces": [
   "the-beach-shirt",
   "the-asher-shorts"
  ],
  "look_pieces": [
   "the-beach-shirt",
   "the-asher-shorts"
  ],
  "fit_ok": true
 },
 {
  "handle": "the-asher-shorts-2",
  "title": "The Asher Shorts",
  "style": "asher",
  "color": "Stripe",
  "price": 168,
  "inv": 162,
  "badge": "",
  "img": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-asher-shorts-2-0.jpg?v=86940818010291726931793801350",
  "img2": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-asher-shorts-2-1.jpg?v=76350200647749151291793801350",
  "sizes": [
   {
    "s": "XS",
    "q": 33
   },
   {
    "s": "S",
    "q": 39
   },
   {
    "s": "M",
    "q": 61
   },
   {
    "s": "L",
    "q": 29
   }
  ],
  "set_pieces": [
   "the-paige-shirt-stripe",
   "the-hailey-trouser-1"
  ],
  "look_pieces": [
   "the-paige-shirt-stripe",
   "the-hailey-trouser-1"
  ],
  "fit_ok": true
 },
 {
  "handle": "the-asher-shorts-3",
  "title": "The Asher Shorts",
  "style": "asher",
  "color": "Black",
  "price": 168,
  "inv": 103,
  "badge": "",
  "img": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-asher-shorts-3-1.jpg?v=43767709912439064911793801354",
  "img2": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-asher-shorts-3-2.jpg?v=88366406421819844401793801354",
  "sizes": [
   {
    "s": "XS",
    "q": 21
   },
   {
    "s": "S",
    "q": 41
   },
   {
    "s": "M",
    "q": 16
   },
   {
    "s": "L",
    "q": 25
   }
  ],
  "set_pieces": [
   "the-paige-shirt",
   "the-hailey-trouser-3"
  ],
  "look_pieces": [
   "the-paige-shirt",
   "the-hailey-trouser-3"
  ],
  "fit_ok": true
 },
 {
  "handle": "the-asher-shorts",
  "title": "The Asher Shorts",
  "style": "asher",
  "color": "Polka Dot",
  "price": 168,
  "inv": 102,
  "badge": "",
  "img": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-asher-shorts-1.jpg?v=177458428207045222201793801349",
  "img2": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-asher-shorts-2.jpg?v=53110048757146704481793801353",
  "sizes": [
   {
    "s": "XS",
    "q": 32
   },
   {
    "s": "S",
    "q": 33
   },
   {
    "s": "M",
    "q": 15
   },
   {
    "s": "L",
    "q": 22
   }
  ],
  "set_pieces": [
   "the-beach-shirt",
   "the-kaitlin-pants"
  ],
  "look_pieces": [
   "the-beach-shirt",
   "the-kaitlin-pants"
  ],
  "fit_ok": true
 },
 {
  "handle": "the-bridgett-skirt",
  "title": "The Bridgett Skirt",
  "style": "bridgett",
  "color": "Polka Dot",
  "price": 198,
  "inv": 103,
  "badge": "",
  "img": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-bridgett-skirt-5.jpg?v=88797270124675210531793801368",
  "img2": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-bridgett-skirt-8.jpg?v=57685217317126401791793801369",
  "sizes": [
   {
    "s": "XS",
    "q": 47
   },
   {
    "s": "S",
    "q": 25
   },
   {
    "s": "M",
    "q": 17
   },
   {
    "s": "L",
    "q": 14
   }
  ],
  "set_pieces": [],
  "look_pieces": [],
  "fit_ok": true
 },
 {
  "handle": "the-bridgett-skirt-1",
  "title": "The Bridgett Skirt",
  "style": "bridgett",
  "color": "Black",
  "price": 198,
  "inv": 65,
  "badge": "BESTSELLER",
  "img": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-bridgett-skirt-1-0.jpg?v=150953212131593830471793801363",
  "img2": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-bridgett-skirt-1-1.jpg?v=106657504376986191051793801363",
  "sizes": [
   {
    "s": "XS",
    "q": 7
   },
   {
    "s": "S",
    "q": 18
   },
   {
    "s": "M",
    "q": 32
   },
   {
    "s": "L",
    "q": 8
   }
  ],
  "set_pieces": [
   "the-new-landon-tank"
  ],
  "look_pieces": [
   "the-new-landon-tank"
  ],
  "fit_ok": true
 },
 {
  "handle": "the-new-landon-tank",
  "title": "The New Landon Tank",
  "style": "landon",
  "color": "Black",
  "price": 168,
  "inv": 106,
  "badge": "",
  "img": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-new-landon-tank-0.jpg?v=69741987833773057231793801385",
  "img2": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-new-landon-tank-1.jpg?v=51314154234938497551793801385",
  "sizes": [
   {
    "s": "XS",
    "q": 23
   },
   {
    "s": "S",
    "q": 17
   },
   {
    "s": "M",
    "q": 29
   },
   {
    "s": "L",
    "q": 37
   }
  ],
  "set_pieces": [
   "the-bridgett-skirt-1"
  ],
  "look_pieces": [
   "the-bridgett-skirt-1"
  ],
  "fit_ok": true
 },
 {
  "handle": "the-new-landon",
  "title": "The New Landon Tank",
  "style": "landon",
  "color": "Stripe",
  "price": 168,
  "inv": 103,
  "badge": "",
  "img": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-new-landon-0.jpg?v=106970549623171344891793801382",
  "img2": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-new-landon-2.jpg?v=1741242465611981881793801383",
  "sizes": [
   {
    "s": "XS",
    "q": 25
   },
   {
    "s": "S",
    "q": 22
   },
   {
    "s": "M",
    "q": 32
   },
   {
    "s": "L",
    "q": 24
   }
  ],
  "set_pieces": [],
  "look_pieces": [],
  "fit_ok": true
 },
 {
  "handle": "the-vacation-pants-copy",
  "title": "The Vacation Pant",
  "style": "vacation",
  "color": "White",
  "price": 188,
  "inv": 76,
  "badge": "",
  "img": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-vacation-pants-copy-0.jpg?v=128134704218493698191793801417",
  "img2": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-vacation-pants-copy-2.jpg?v=161365781709779502661793801418",
  "sizes": [
   {
    "s": "XS",
    "q": 9
   },
   {
    "s": "S",
    "q": 23
   },
   {
    "s": "M",
    "q": 35
   },
   {
    "s": "L",
    "q": 9
   }
  ],
  "set_pieces": [
   "the-paige-beach-shirt"
  ],
  "look_pieces": [
   "the-paige-beach-shirt"
  ],
  "fit_ok": true
 },
 {
  "handle": "search-for-surf-tour-sweatshirt-tan-on-tan",
  "title": "Search for Surf Tour Sweatshirt",
  "style": "apres-sweatshirt",
  "color": "Tan on Tan",
  "price": 138,
  "inv": 30,
  "badge": "NEW IN",
  "img": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-search-for-surf-tour-sweatshirt-tan-on-tan-0.jpg?v=121839170851153147751793801347",
  "img2": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-search-for-surf-tour-sweatshirt-tan-on-tan-1.jpg?v=44419471388261449271793801347",
  "sizes": [
   {
    "s": "Small",
    "q": 10
   },
   {
    "s": "Medium",
    "q": 10
   },
   {
    "s": "Large",
    "q": 10
   }
  ],
  "set_pieces": [],
  "look_pieces": [],
  "fit_ok": true
 },
 {
  "handle": "search-for-surf-tour-sweatshirt-black-on-black",
  "title": "Search for Surf Tour Sweatshirt",
  "style": "apres-sweatshirt",
  "color": "Black on Black",
  "price": 138,
  "inv": 30,
  "badge": "NEW IN",
  "img": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-search-for-surf-tour-sweatshirt-black-on-black-0.jpg?v=59848704596974823471793801345",
  "img2": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-search-for-surf-tour-sweatshirt-black-on-black-1.jpg?v=52251223931838861041793801345",
  "sizes": [
   {
    "s": "Small",
    "q": 10
   },
   {
    "s": "Medium",
    "q": 10
   },
   {
    "s": "Large",
    "q": 10
   }
  ],
  "set_pieces": [],
  "look_pieces": [],
  "fit_ok": true
 },
 {
  "handle": "search-for-surf-tour-sweatshirt-white-with-royal-blue",
  "title": "Search for Surf Tour Sweatshirt",
  "style": "apres-sweatshirt",
  "color": "White with Royal Blue",
  "price": 138,
  "inv": 30,
  "badge": "NEW IN",
  "img": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-search-for-surf-tour-sweatshirt-white-with-royal-blue-0.jpg?v=58974402308831920381793801348",
  "img2": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-search-for-surf-tour-sweatshirt-white-with-royal-blue-1.jpg?v=73186267701948479701793801348",
  "sizes": [
   {
    "s": "Small",
    "q": 10
   },
   {
    "s": "Medium",
    "q": 10
   },
   {
    "s": "Large",
    "q": 10
   }
  ],
  "set_pieces": [],
  "look_pieces": [],
  "fit_ok": true
 },
 {
  "handle": "search-for-surf-tour-sweatshirt-red-on-red",
  "title": "Search for Surf Tour Sweatshirt",
  "style": "apres-sweatshirt",
  "color": "Red on Red",
  "price": 138,
  "inv": 30,
  "badge": "NEW IN",
  "img": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-search-for-surf-tour-sweatshirt-red-on-red-0.jpg?v=98397186268735183851793801346",
  "img2": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-search-for-surf-tour-sweatshirt-red-on-red-1.jpg?v=88617733844567283901793801346",
  "sizes": [
   {
    "s": "Small",
    "q": 10
   },
   {
    "s": "Medium",
    "q": 10
   },
   {
    "s": "Large",
    "q": 10
   }
  ],
  "set_pieces": [],
  "look_pieces": [],
  "fit_ok": true
 },
 {
  "handle": "the-travel-t",
  "title": "The Travel T",
  "style": "travel-t",
  "color": "Black",
  "price": 158,
  "inv": 31,
  "badge": "NEW IN",
  "img": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-travel-t-0.jpg?v=97012051214983777821793801413",
  "img2": "//thisistheshoreline.com/cdn/shop/t/22/assets/pdp-the-travel-t-1.jpg?v=139451696524032563311793801414",
  "sizes": [
   {
    "s": "XS",
    "q": 8
   },
   {
    "s": "S",
    "q": 9
   },
   {
    "s": "M",
    "q": 9
   },
   {
    "s": "L",
    "q": 5
   }
  ],
  "set_pieces": [],
  "look_pieces": [],
  "fit_ok": true
 }
];
window.GROUPS = {
 "new": [
  "search-for-surf-tour-sweatshirt-tan-on-tan",
  "search-for-surf-tour-sweatshirt-black-on-black",
  "search-for-surf-tour-sweatshirt-white-with-royal-blue",
  "search-for-surf-tour-sweatshirt-red-on-red",
  "the-travel-t",
  "the-shea-long-sleeve-t-shirt-dress-white"
 ],
 "best": [
  "the-shea-t-shirt-dress-white",
  "the-paige-shirt-stripe",
  "the-hailey-trouser-1",
  "the-bridgett-skirt-1",
  "the-shea-t-shirt-dress"
 ],
 "sets": [
  "the-paige-beach-shirt",
  "the-vacation-pants-copy",
  "the-paige-shirt",
  "the-asher-shorts-3",
  "the-hailey-trouser-3",
  "the-bridgett-skirt-1",
  "the-new-landon-tank",
  "the-paige-shirt-stripe",
  "the-asher-shorts-2",
  "the-hailey-trouser-1",
  "the-new-landon",
  "the-paige-beach-shirt-1",
  "the-hailey-trouser",
  "the-beach-shirt",
  "the-asher-shorts",
  "the-kaitlin-pants",
  "the-bridgett-skirt"
 ],
 "passport": [
  "the-paige-beach-shirt",
  "the-bridgett-skirt",
  "the-shea-t-shirt-dress-white",
  "the-shea-long-sleeve-t-shirt-dress-white"
 ]
};
window.STYLES = {
 "shea": [
  "the-shea-t-shirt-dress-white",
  "the-shea-t-shirt-dress",
  "the-shea-long-sleeve-t-shirt-dress-white",
  "the-shea-long-sleeve-t-shirt-dress"
 ],
 "beach-shirt": [
  "the-paige-beach-shirt",
  "the-paige-shirt",
  "the-paige-shirt-stripe",
  "the-paige-beach-shirt-1",
  "the-beach-shirt"
 ],
 "kaitlin": [
  "the-hailey-trouser-1",
  "the-hailey-trouser-3",
  "the-hailey-trouser",
  "the-kaitlin-pants"
 ],
 "asher": [
  "the-asher-shorts-2",
  "the-asher-shorts-3",
  "the-asher-shorts"
 ],
 "bridgett": [
  "the-bridgett-skirt",
  "the-bridgett-skirt-1"
 ],
 "landon": [
  "the-new-landon-tank",
  "the-new-landon"
 ],
 "vacation": [
  "the-vacation-pants-copy"
 ],
 "apres-sweatshirt": [
  "search-for-surf-tour-sweatshirt-tan-on-tan",
  "search-for-surf-tour-sweatshirt-black-on-black",
  "search-for-surf-tour-sweatshirt-white-with-royal-blue",
  "search-for-surf-tour-sweatshirt-red-on-red"
 ],
 "travel-t": [
  "the-travel-t"
 ]
};
